import Vue, { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'

import ApiClient, { ApiCallError, ERROR_MAP } from '@src/lib/api_client'
import { Input } from '@src/elements/input/input'
import { validatePassword, validateRequiredField } from '@src/util/validation'
import { Button } from '@src/elements/button/button'
import { Subtitle1 } from '@src/elements/typography/typography'
import { API } from '@src/lib/api_path'
import { highlightFulfilledRequirements } from '@src/util/functions'
import { ContentBox } from '@src/elements/content-box/content-box'
import { PasswordRequirements } from '@src/components/password-requirements/password-requirements'
import SessionManager from '@src/lib/session_manager'

@Component
export default class TrainerChangePassword extends Vue {

  private apiClient: ApiClient

  private currentPassword: string = ''
  private newPassword: string = ''
  private confirmPassword: string = ''

  private fieldErrors: string[] = []

  private highlightRequirements = {
    minLength: false,
    oneLetter: false,
    oneNumber: false,
    sameAsConfirm: false
  }

  constructor () {
    super()
    this.apiClient = new ApiClient(API.TRAINERS_API.PASSWORDS)
  }

  changePassword () {

    this.validateForm()

    if (this.fieldErrors.length === 0) {
      this.apiClient.put(`?current_password=${this.currentPassword}&new_password=${this.newPassword}`, {})
        .then(() => {
          this.$store.dispatch('showToast', { message: this.$t('PAGE.MEMBERS.CHANGE_PASSWORD.CHANGE_PASSWORD_DONE'), fadeOut: true })
          this.currentPassword = ''
          this.newPassword = ''
          this.confirmPassword = ''
          SessionManager.Instance.logout()
          window.location.reload.call(window.location)
        })
        .catch((error: ApiCallError) => {
          if (error.messageKey === ERROR_MAP['401'] || error.messageKey === ERROR_MAP['403']) {
            this.fieldErrors.push('currentPassword')
          } else if (error.messageKey === ERROR_MAP['422']) {
            this.fieldErrors.push('newPassword')
          }
        })
    }
  }

  validateForm () {
    let fieldErrors: string [] = []

    if (validateRequiredField(this.currentPassword)) {
      fieldErrors.push('currentPassword')
    }
    if (!validatePassword(this.newPassword)) {
      fieldErrors.push('newPassword')
    }
    if (this.newPassword !== this.confirmPassword) {
      fieldErrors.push('confirmPassword')
    }

    this.fieldErrors = fieldErrors
  }

  setNewPassword (value: string) {
    this.newPassword = value

    this.highlightRequirements = highlightFulfilledRequirements(this.newPassword, this.confirmPassword)
  }

  setConfirmPassword (value: string) {
    this.confirmPassword = value

    this.highlightRequirements = highlightFulfilledRequirements(this.newPassword, this.confirmPassword)
  }

  render (h: CreateElement) {

    return <div class='change-password' direction='column'>
      <Subtitle1>{this.$t('PAGE.MEMBERS.CHANGE_PASSWORD.CHANGE_YOUR_PASSWORD')}</Subtitle1>

      <ContentBox>
        <div slot='content'>
          <div class='row'>
            <Input ref='currentPassword' type='password' class={`short ${this.fieldErrors.indexOf('currentPassword') >= 0 ? 'error' : ''}`} value={this.currentPassword}
                   valueChanged={(value: string) => this.currentPassword = value} label={`${this.$t('PAGE.MEMBERS.CHANGE_PASSWORD.CURRENT')}*`} />
          </div>
          <div class='row'>
            <Input ref='newPassword' type='password' class={`short ${this.fieldErrors.indexOf('newPassword') >= 0 ? 'error' : ''}`} value={this.newPassword}
                   valueChanged={this.setNewPassword} label={`${this.$t('PAGE.MEMBERS.CHANGE_PASSWORD.NEW')}*`} />
          </div>
          <div class='row'>
            <Input ref='confirmPassword' type='password' class={`short ${this.fieldErrors.indexOf('confirmPassword') >= 0 ? 'error' : ''}`} value={this.confirmPassword}
                   valueChanged={this.setConfirmPassword} label={`${this.$t('PAGE.MEMBERS.CHANGE_PASSWORD.CONFIRM')}*`} />
          </div>

          <PasswordRequirements highlightRequirements={this.highlightRequirements} />
        </div>

        <div class='btn-row' slot='bottom'>
          <Button class='save-btn' label={this.$t('PAGE.MEMBERS.CHANGE_PASSWORD.CHANGE_PASSWORD')} click={this.changePassword} ref='changePassword' type='elevated' />
        </div>
      </ContentBox>
    </div>
  }
}
